import { useCallback } from 'react';
import { ColumnFiltersState, Updater } from '@tanstack/react-table';
import { TableStateManager } from '@common/components/table/types';

export type ContextedColumnFilterUpdater = (
  updaterOrValue: Updater<ColumnFiltersState>,
) => void;

export function useControlledColumnFilters({
  resetPagination,
  tableStateManager,
}: {
  resetPagination: () => void;
  tableStateManager: TableStateManager;
}) {
  const [columnFiltersState, setcolumnFiltersState] =
    tableStateManager.useColumnFiltersState([]);

  // This is the function that can be used to update the column filters state.
  // If the provided updater is a function, it will be used to update the
  // column filters state. Otherwise, the provided value will be used to
  // directly update the state. In either case, the pagination will be reset.
  const onColumnFiltersChange: ContextedColumnFilterUpdater = useCallback(
    (updater) => {
      setcolumnFiltersState((prevFiltersState: ColumnFiltersState) => {
        // Evaluate new filter state
        let newFilterState: ColumnFiltersState;
        if (typeof updater === 'function') {
          newFilterState = updater(prevFiltersState);
        } else {
          newFilterState = updater;
        }

        return newFilterState;
      });
      resetPagination();
    },
    [setcolumnFiltersState],
  );

  return { columnFiltersState, onColumnFiltersChange };
}
